export default {
  en: {
    'sponsor_offers': 'sponsor offers',
    'per_league_match': 'per league match',
    'per_league_victory': 'per league victory',
    'per_cup_match': 'per cup match',
    'per_cup_victory': 'per cup victory',
    'accepted': 'accepted',
    'accept': 'accept',
    'accepted_sponsoring': 'accepted sponsoring',
    'accept_sponsor_offer?': 'accept sponsor offer?',
    'league_match_victory': 'league match victory',
    'cup_match_victory': 'cup match victory',
    'league_match': 'league match',
    'cup_match': 'cup match',
    'sponsoring': 'sponsoring',
    '': '',
  }
};
